<template>
  <div>
    <h2>Team</h2>
    <p>Meet our wonderful team.</p>
  </div>
</template>

<script>
export default {
  name: 'Team'
}
</script>